export const SUBMITTAL_STATUS = {
	DRAFT: 'DRAFT',
	PENDING_REVIEW: 'PENDING_REVIEW',
	APPROVED: 'APPROVED',
	REJECTED: 'REJECTED',
	REPLACED: 'REPLACED',
	DELETED: 'DELETED',
	PASSED_DEADLINE: 'PASSED_DEADLINE',
};

// Statuses where the submittal is locked from further edits.
// Used by the listing menu, the detail page, and the edit-page guard.
export const NON_EDITABLE_STATUSES = new Set([
	SUBMITTAL_STATUS.APPROVED,
	SUBMITTAL_STATUS.DELETED,
	SUBMITTAL_STATUS.REPLACED,
	SUBMITTAL_STATUS.PASSED_DEADLINE,
]);
